import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Tabs, Tab } from "@mui/material";

import { RequestRole } from "../../../../types/brm/request-types";
import { AppDispatch, RootState } from "../../../../store";
import { useDispatch } from "react-redux";
import { setModelingSelectedRole, selectModelingSelectedRole, selectChangeRequestStage } from "../../../../reducers/administration/requestSlice";
import RequestSingleRoleModelingBox from "./request-single-role-modeling-box";
import RequestGroupRoleModelingBox from "./request-group-role-modeling-role";
import RequestDetailedRolesTable from "./request-detailed-roles-table";
import { ProgressDialog } from "../../../common/dialogs";
import "./styles.less";
import { requestStages } from "../../../../utils/brm-utils";
import { useIntl } from "react-intl";

const RequestDetailedRolesTab: React.FC<{ resetTabSignal?: number }> = ({ resetTabSignal = 0 }) => {
    const dispatch = useDispatch<AppDispatch>();
    const intl = useIntl();
    const roles = useSelector((state: RootState) => state.administration.requests.rolesForView.roles);
    const busy = useSelector((state: RootState) => state.administration.requests.busy);
    const busyType = useSelector((state: RootState) => state.administration.requests.busyType);
    const readMode = useSelector((state: RootState) => state.administration.requests.currentRequest?.readMode);
    const currentRequestEditable = useSelector((state: RootState) => state.administration.requests.currentRequest?.currentRequestEditable);
    const modelingRole = useSelector(selectModelingSelectedRole);
    const currentRequestStatus = useSelector(selectChangeRequestStage);
    const [currentTab, setCurrentTab] = useState(0);

    const roleForEditDisabled = currentRequestStatus !== requestStages.ROLE_DEFINITION || readMode || !currentRequestEditable;
    useEffect(() => {
        setCurrentTab(0);
    }, [resetTabSignal]);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setCurrentTab(newValue);
    };

    useEffect(() => {
        if (currentTab !== 0) {
            const selectedRole = roles[currentTab - 1];
            dispatch(setModelingSelectedRole(selectedRole));
        }
    }, [currentTab, dispatch, roles]);

    return (
        <>
            <Box>
                <Box
                    sx={{
                        backgroundColor: "white",
                        borderRadius: "12px 12px 0 0",
                    }}
                >
                    <Tabs className="request-roles-table-tabs" value={currentTab} onChange={handleChange} variant="scrollable" scrollButtons="auto">
                        {[intl.formatMessage({ id: "request-detailed-roles-table-title" }), ...roles.map((item: RequestRole) => item.role)].map((label, index) => (
                            <Tab
                                className="request-roles-table-tab"
                                key={index}
                                label={label}
                                sx={{
                                    backgroundColor: currentTab === index ? "white" : "transparent",
                                    "&:hover": {
                                        backgroundColor: currentTab === index ? "white" : "#E0E0E0",
                                    },
                                }}
                            />
                        ))}
                    </Tabs>
                </Box>

                <Box>
                    {currentTab === 0 && <RequestDetailedRolesTable />}
                    {currentTab !== 0 &&
                        (modelingRole?.isComplex ? (
                            <RequestGroupRoleModelingBox disabled={roleForEditDisabled ?? false} />
                        ) : (
                            <RequestSingleRoleModelingBox disabled={roleForEditDisabled ?? false} />
                        ))}
                </Box>
            </Box>
            <ProgressDialog open={busy} busyType={busyType} title="" progress={""} />
        </>
    );
};

export default RequestDetailedRolesTab;
